import {
  GET_HORSE_RACE_AGF_GAME_SELECT,
  GET_HORSE_RACE_AGF_GAME_SELECT_SUCCESS,
  GET_HORSE_RACE_AGF_GAME_SELECT_FAILURE,
  GET_HORSE_RACE_AGF_LIST,
  GET_HORSE_RACE_AGF_LIST_SUCCESS,
  GET_HORSE_RACE_AGF_LIST_FAILURE,
  GET_HORSE_RACE_AGF_HIPPODROMES,
  GET_HORSE_RACE_AGF_HIPPODROMES_SUCCESS,
  GET_HORSE_RACE_AGF_HIPPODROMES_FAILURE,
  SET_SELECTED_AGF_HIPPODROME,
  SET_SELECTED_AGF_LEG,
  SET_SELECTED_AGF_SIX_PICK_ORDER,
  HORSE_RACING_WS_AGF_UPDATE
} from 'Store/constants';

  
const initialState = {
  agfSelectableList: [],
  agfListData: [],
  agfSelectedLeg: {},
  selectedSixPickOrder: 2,
  isLoading: null,
  error: null,

  hippodromes: {
    data: [],
    selectedHippodrome: {},
    isLoading: false,
    error: null,
  }
};
  
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HORSE_RACE_AGF_GAME_SELECT:
      return { ...state, isLoading: true, error: null };
    case GET_HORSE_RACE_AGF_GAME_SELECT_SUCCESS:
      return { ...state, agfSelectableList: action.payload.agfSelectableList, isLoading: false, error: null };
    case GET_HORSE_RACE_AGF_GAME_SELECT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case GET_HORSE_RACE_AGF_LIST:
      return { ...state, isLoading: true, error: null };
    case GET_HORSE_RACE_AGF_LIST_SUCCESS:
      return { ...state, agfListData: action.payload, isLoading: false, error: null };
    case GET_HORSE_RACE_AGF_LIST_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    
    case GET_HORSE_RACE_AGF_HIPPODROMES:
      return { ...state, hippodromes: { ...state.hippodromes, isLoading: true, error: null } };
    case SET_SELECTED_AGF_HIPPODROME:
      return { ...state, hippodromes: { ...state.hippodromes, selectedHippodrome: action.payload } };
    case SET_SELECTED_AGF_LEG:
      return { ...state, agfSelectedLeg: { ...action.payload, index: action.payload.index ?? 1 } };
    case SET_SELECTED_AGF_SIX_PICK_ORDER:
      return { ...state, selectedSixPickOrder: action.payload };
    case GET_HORSE_RACE_AGF_HIPPODROMES_SUCCESS:
      return { ...state, hippodromes: { ...state.hippodromes, data: action.payload, isLoading: false, error: null } };
    case GET_HORSE_RACE_AGF_HIPPODROMES_FAILURE:
      return { ...state, hippodromes: { ...state.hippodromes, isLoading: false, error: action.payload } };
    case HORSE_RACING_WS_AGF_UPDATE:
      return {
        ...state,
        agfListData: { ...state.agfListData, agfList: action.payload.agfListData },
        agfSelectedLeg: { index: state.agfSelectedLeg.index, ...action.payload.agfListData.find(x => +x.raceNo === +state.agfSelectedLeg.raceNo) },
        isLoading: false, error: null
      };
    default:
      return state;
  }
};